import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './MatchManager.css';

const MatchManager = () => {
  const [matches, setMatches] = useState([]);
  const [formData, setFormData] = useState({
    marketid: '',
    matchName: '',
    matchdate: '',
    matchid: '',
    cname: '',
    cid: '',
    teamA: '',
    teamB: '',
    matchType: 'T20',
    totalOvers: 20,
    displayOrder: 0
  });

  // Configure axios defaults
const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  }
});
  useEffect(() => {
    fetchMatches();
  }, []);

  const fetchMatches = async () => {
    try {
      const response = await api.get('/matches');
      setMatches(response.data);
    } catch (error) {
      console.error('Error fetching matches:', error);
      alert('Error fetching matches: ' + (error.response?.data?.error || error.message));
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  
  // Create a unique ID for virtual match
  const uniqueId = Date.now(); // Define uniqueId here
  
  // Also ensure we have a marketid from form or generate one
  const marketIdValue = formData.marketid || uniqueId;
  
  const matchData = {
    marketid: `v${marketIdValue}`,  // Add 'v' prefix to marketid
    matchName: formData.matchName,
    matchdate: new Date(formData.matchdate).toISOString(),
    matchdateC: new Date(formData.matchdate).getTime(),
    matchid: `v${marketIdValue}`,    // Add 'v' prefix to matchid
    cname: formData.cname,
    cid: parseInt(formData.cid),
    matchType: formData.matchType,
    teamA: formData.teamA,
    teamB: formData.teamB,
    totalOvers: formData.matchType === 'T20' ? 20 : 10,
    status: 'upcoming',
    displayOrder: formData.displayOrder || 0,
    odds: {
      bookmaker: { teamA: 1.85, teamB: 1.85 },
      session: {}
    }
  };
  
  // Initialize session odds for each over
  for (let i = 1; i <= matchData.totalOvers; i++) {
    matchData.odds.session[`over${i}`] = 1.85;
  }
  
  console.log('Sending match data:', matchData);
  
try {
  const response = await axios.post('/api/matches/create', matchData);
  console.log('Match created:', response.data);
    // Reset form or show success message
    setFormData({
      marketid: '',
      matchName: '',
      matchdate: '',
      matchid: '',
      cname: '',
      cid: '',
      teamA: '',
      teamB: '',
      matchType: 'T20',
      totalOvers: 20,
      displayOrder: 0
    });
    alert('Match created successfully!');
    // Refresh matches list
    fetchMatches();
  } catch (error) {
    console.error('Error creating match:', error);
    alert('Error creating match: ' + (error.response?.data?.error || error.message));
  }
};

  const updateMatchStatus = async (marketid, status) => {
    try {
      await api.put(`/matches/${marketid}/status`, { status });
      fetchMatches();
    } catch (error) {
      console.error('Error updating status:', error);
      alert('Error updating status: ' + (error.response?.data?.error || error.message));
    }
  };

  const deleteMatch = async (marketid) => {
    if (window.confirm('Are you sure you want to delete this match?')) {
      try {
        await api.delete(`/matches/${marketid}`);
        fetchMatches();
        alert('Match deleted successfully!');
      } catch (error) {
        console.error('Error deleting match:', error);
        alert('Error deleting match: ' + (error.response?.data?.error || error.message));
      }
    }
  };

  return (
    <div className="match-manager">
      <div className="create-match-form">
        <h2>Create New Cricket Match</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <input
              type="number"
              placeholder="Market ID *"
              value={formData.marketid}
              onChange={(e) => setFormData({...formData, marketid: e.target.value})}
              required
            />
            <input
              type="text"
              placeholder="Match Name *"
              value={formData.matchName}
              onChange={(e) => setFormData({...formData, matchName: e.target.value})}
              required
            />
          </div>
          
          <div className="form-row">
            <input
              type="number"
              placeholder="Match ID *"
              value={formData.matchid}
              onChange={(e) => setFormData({...formData, matchid: e.target.value})}
              required
            />
            <input
              type="text"
              placeholder="C Name (Tournament) *"
              value={formData.cname}
              onChange={(e) => setFormData({...formData, cname: e.target.value})}
              required
            />
          </div>
          
          <div className="form-row">
            <input
              type="number"
              placeholder="C ID *"
              value={formData.cid}
              onChange={(e) => setFormData({...formData, cid: e.target.value})}
              required
            />
            <input
              type="datetime-local"
              placeholder="Match Date & Time *"
              value={formData.matchdate}
              onChange={(e) => setFormData({...formData, matchdate: e.target.value})}
              required
            />
          </div>
          
          <div className="form-row">
            <input
              type="text"
              placeholder="Team A *"
              value={formData.teamA}
              onChange={(e) => setFormData({...formData, teamA: e.target.value})}
              required
            />
            <input
              type="text"
              placeholder="Team B *"
              value={formData.teamB}
              onChange={(e) => setFormData({...formData, teamB: e.target.value})}
              required
            />
          </div>
          
          <div className="form-row">
            <select
              value={formData.matchType}
              onChange={(e) => setFormData({...formData, matchType: e.target.value})}
            >
              <option value="T5">T5 (5 Overs)</option>
              <option value="T20">T20 (20 Overs)</option>
              <option value="T10">T10 (10 Overs)</option>
            </select>
            <input
              type="number"
              placeholder="Display Order"
              value={formData.displayOrder}
              onChange={(e) => setFormData({...formData, displayOrder: parseInt(e.target.value)})}
            />
          </div>
          
          <button type="submit">Create Match</button>
        </form>
      </div>

      <div className="matches-list">
        <h2>All Matches</h2>
        <div className="matches-table-container">
          <table className="matches-table">
            <thead>
              <tr>
                <th>Market ID</th>
                <th>Match Name</th>
                <th>Teams</th>
                <th>Tournament</th>
                <th>Type</th>
                <th>Status</th>
                <th>Odds</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {matches.map(match => (
                <tr key={match.marketid}>
                  <td>{match.marketid}</td>
                  <td>{match.matchName}</td>
                  <td>{match.teamA} vs {match.teamB}</td>
                  <td>{match.cname}</td>
                  <td>{match.matchType}</td>
                  <td>
                    <span className={`status-badge status-${match.status}`}>
                      {match.status}
                    </span>
                  </td>
                  <td>
                    {match.odds?.bookmaker?.teamA} / {match.odds?.bookmaker?.teamB}
                  </td>
                  <td className="actions">
                    {match.status === 'upcoming' && (
                      <button 
                        className="btn-start"
                        onClick={() => updateMatchStatus(match.marketid, 'live')}
                      >
                        Start
                      </button>
                    )}
                    {match.status === 'live' && (
                      <button 
                        className="btn-pause"
                        onClick={() => updateMatchStatus(match.marketid, 'paused')}
                      >
                        Pause
                      </button>
                    )}
                    {match.status === 'paused' && (
                      <button 
                        className="btn-resume"
                        onClick={() => updateMatchStatus(match.marketid, 'live')}
                      >
                        Resume
                      </button>
                    )}
                    <button 
                      className="btn-delete"
                      onClick={() => deleteMatch(match.marketid)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MatchManager;